import { render, staticRenderFns } from "./supportMenu.vue?vue&type=template&id=1750f950&scoped=true&"
import script from "./supportMenu.vue?vue&type=script&lang=ts&"
export * from "./supportMenu.vue?vue&type=script&lang=ts&"
import style0 from "./supportMenu.vue?vue&type=style&index=0&id=1750f950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1750f950",
  null
  
)

export default component.exports